import React, { useEffect, useState } from 'react';
import MaterialTable from 'material-table';
import { useHistory } from 'react-router-dom';
import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Modal, Button, Form, Col,
} from 'react-bootstrap';
import { Error, Success } from '../Alert/index';
import api from '../../services/api';

export function UsersPanelList () {
  const history = useHistory();
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [user, setUser] = useState({
    _id: '',
    name: '',
    email: '',
    password: '',
    college: {},
    permissions: [],
  });
  const [users, setUsers] = useState([]);
  const [show, setShow] = useState(false);
  const [colleges, setColleges] = useState([]);
  const [permissions, setPermissions] = useState([]);
  const [components, setComponents] = useState([]);
  const handleClose = () => setShow(false);

  // Busca lista de usuários
  useEffect(() => {
    api.get('/users')
      .then((res) => {
        setUsers(res.data);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          setError(true);
          const element = document.getElementById('msgError');
          element.innerHTML = 'Sua sessão expirou. Realize o login novamente para continuar';
          setTimeout(() => {
            localStorage.removeItem('logged');
            localStorage.removeItem('realm');
            history.go('/login');
          }, 2000);
        }
      });
  }, [history]);

  // busca lista de colleges
  useEffect(() => {
    api.get('/colleges')
      .then((res) => setColleges(res.data))
      .catch((err) => {
        if (err.response.status === 401) {
          setError(true);
          const element = document.getElementById('msgError');
          element.innerHTML = 'Sua sessão expirou. Realize o login novamente para continuar';
          setTimeout(() => {
            localStorage.removeItem('logged');
            localStorage.removeItem('realm');
            history.go('/login');
          }, 2000);
        }
      });
  }, [history]);

  // busca lista de components
  useEffect(() => {
    api.get('/components')
      .then((res) => setComponents(res.data))
      .catch((err) => {
        if (err.response.status === 401) {
          setError(true);
          const element = document.getElementById('msgError');
          element.innerHTML = 'Sua sessão expirou. Realize o login novamente para continuar';
          setTimeout(() => {
            localStorage.removeItem('logged');
            localStorage.removeItem('realm');
            history.go('/login');
          }, 2000);
        }
      });
  }, [history]);

  function deleteUser (oldValue) {
    console.log(oldValue._id);
    // api.delete(`/users/${oldValue._id}`)
    //   .then((res) => {
    //     setUsers(res.data);
    //     setSuccess(true);
    //     document.getElementById('msgSuccess').innerHTML = 'Usuário removido com sucesso!';
    //     setTimeout(() => setSuccess(false), 3000);
    //   })
    //   .catch((err) => {
    //     if (err.response.status === 401) {
    //       setError(true);
    //       const element = document.getElementById('msgError');
    //       element.innerHTML = 'Sua sessão expirou. Realize o login novamente para continuar';
    //       setTimeout(() => {
    //         localStorage.removeItem('logged');
    //         localStorage.removeItem('realm');
    //         history.go('/login');
    //       }, 2000);
    //     } else {
    //       setError(true);
    //       document.getElementById('msgError').innerHTML = err.response.data.error;
    //       setTimeout(() => setError(false), 3000);
    //     }
    //   });
  }

  function updateComponents () {
    api.get('/components')
      .then((res) => {
        setComponents(res.data);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          setError(true);
          const element = document.getElementById('msgError');
          element.innerHTML = 'Sua sessão expirou. Realize o login novamente para continuar';
          setTimeout(() => {
            localStorage.removeItem('logged');
            localStorage.removeItem('realm');
            history.go('/login');
          }, 2000);
        }
      });
  }

  function handleSubmit (event, rowData) {
    const listColleges = [];
    colleges.forEach((element) => {
      if (element._id !== rowData.college._id) {
        listColleges.push(element);
      }
    });

    const list = [];
    components.forEach((element) => {
      const retorno = rowData.permissions.find((e) => e._id === element._id);
      if (!retorno) {
        const ret = list.find((e) => e._id === element._id);
        if (!ret) {
          list.push(element);
        }
      }
    });

    setColleges(listColleges);
    setComponents(list);
    setUser({
      _id: rowData._id,
      name: rowData.name,
      email: rowData.email,
      password: '',
      college: rowData.college,
      permissions: rowData.permissions,
    });
    setShow(true);
  }

  async function usersUpdate () {
    try {
      const res = await api.get('/users');
      setUsers(res.data);
    } catch (err) {
      if (err.response.status === 401) {
        setError(true);
        const element = document.getElementById('msgError');
        element.innerHTML = 'Sua sessão expirou. Realize o login novamente para continuar';
        setTimeout(() => {
          localStorage.removeItem('logged');
          localStorage.removeItem('realm');
          history.go('/login');
        }, 2000);
      }
    }
  }

  function changeComponents (e) {
    const perm = JSON.parse(e.target.value);
    const filter = permissions.filter((item) => item._id !== perm._id);
    setPermissions(filter);
    const comp = components;
    comp.push(perm);
    setComponents(comp);
  }

  function changePermissions (e) {
    const comp = JSON.parse(e.target.value);
    const filter = components.filter((item) => item._id !== comp._id);
    setComponents(filter);
    const perm = permissions;
    perm.push(comp);
    setPermissions(perm);
  }
  function handleSubmitUpdateUser () {
    const permissionsList = [];
    permissions.forEach((element) => {
      permissionsList.push(element._id);
    });
    api.put('users', {
      user: {
        _id: user._id,
        name: user.name,
        email: user.email,
        password: user.password,
        college: user.college._id,
        permissions: permissionsList,
      },
    })
      .then(() => {
        updateComponents();
        setSuccess(true);
        setUser({
          name: '',
          email: '',
          password: '',
          college: '',
        });
        setPermissions([]);
        setShow(false);
        const element = document.getElementById('msgSuccess');
        element.innerHTML = 'Usuário cadastrado com sucesso';
        setTimeout(() => setSuccess(false), 3000);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          setError(true);
          const element = document.getElementById('msgError');
          element.innerHTML = 'Sua sessão expirou. Realize o login novamente para continuar';
          setTimeout(() => {
            localStorage.removeItem('logged');
            localStorage.removeItem('realm');
            history.go('/login');
          }, 2000);
        } else {
          setError(true);
          const element = document.getElementById('msgError');
          element.innerHTML = err.response.data.error;
          setTimeout(() => setError(false), 3000);
        }
      });
  }
  function handleChangeValues (event) {
    if (event.target.name === 'college') {
      setUser({ ...user, [event.target.name]: JSON.parse(event.target.value) });
    } else {
      setUser({ ...user, [event.target.name]: event.target.value });
    }
  }

  return (
    <>
      <div className="content-list">
        {error ? <Error><p id="msgError" /></Error> : null}
        {success ? <Success><p id="msgSuccess" /></Success> : null}
        <section className="update">
          <div
            className="update-table"
            onClick={usersUpdate}
            aria-hidden="true"
          >
            <p>Atualizar</p>
            <FontAwesomeIcon icon={faSyncAlt} size="lg" color="white" />
          </div>
        </section>
        <MaterialTable
          title="Usuários"
          columns={[
            { width: 200, title: 'Nome', field: 'name' },
            { title: 'E-mail', field: 'email' },
            { title: 'Instituição', field: 'college.name' },
          ]}
          localization={{
            header: {
              actions: 'Oções',
            },
            body: {
              emptyDataSourceMessage: 'Sem dados para mostrar',
              deleteTooltip: 'Remover',
              addTooltip: 'Adicionar Usuário',
              editTooltip: 'Editar',
              editRow: {
                cancelTooltip: 'Cancelar',
                deleteText: 'Tem certeza que deseja remover',
                saveTooltip: 'Confirmar',
              },

            },
            toolbar: {
              searchPlaceholder: 'Buscar',
              searchTooltip: 'Buscar',
            },
          }}
          data={users}
          actions={[
            {
              icon: 'edit',
              tooltip: 'Save User',
              onClick: (event, rowData) => {
                handleSubmit(event, rowData); setPermissions(rowData.permissions);
              },
            },
          ]}
          editable={{
            onRowDelete: (oldValue) => new Promise((resolve) => {
              deleteUser(oldValue);
              setTimeout(() => resolve(), 2000);
            }),
          }}
        />
      </div>

      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Editar o usuário
            {' '}
            {user.name}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Row>
              <Form.Group as={Col} md="6" controlId="validationFullName">
                <Form.Label>Nome completo</Form.Label>
                <Form.Control
                  required
                  name="name"
                  type="text"
                  value={user.name}
                  placeholder="Nome completo"
                  onChange={handleChangeValues}
                />
                <Form.Control.Feedback type="invalid">
                  Por favor, entre com o nome do usuário.
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} md="6" controlId="validationEmail">
                <Form.Label>E-mail</Form.Label>
                <Form.Control
                  required
                  name="email"
                  type="email"
                  value={user.email}
                  placeholder="E-mail"
                  onChange={handleChangeValues}
                />
                <Form.Control.Feedback type="invalid">
                  Por favor, entre com o e-mail do usuário.
                </Form.Control.Feedback>
              </Form.Group>
            </Form.Row>
            <Form.Row>
              <Form.Group as={Col} md="6" controlId="validationPassword1">
                <Form.Label>Senha</Form.Label>
                <Form.Control
                  required
                  name="password"
                  type="password"
                  value={user.newPassword}
                  placeholder="Senha"
                  onChange={handleChangeValues}
                />
                <Form.Control.Feedback type="invalid">
                  Por favor, entre com a senha do usuário.
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} md="6" controlId="validationSelectt">
                <Form.Label>Instituição</Form.Label>
                <Form.Control
                  as="select"
                  name="college"
                  custom
                  required
                  onChange={handleChangeValues}
                >
                  <option
                    value={
                      JSON.stringify(user.college)
                    }
                    selected
                  >
                    {user.college.name}

                  </option>
                  {colleges.map((college) => (
                    <option
                      value={
                        JSON.stringify(college)
                      }
                      key={college._id}
                    >
                      {college.name}

                    </option>

                  ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  Por favor, entre com a instituição.
                </Form.Control.Feedback>
              </Form.Group>
            </Form.Row>
            <Form.Row>
              <Form.Group as={Col} md="6" controlId="validationSelectt">
                <Form.Label>Todas as permissões</Form.Label>
                <Form.Control
                  as="select"
                  name="college"
                  custom
                  multiple
                  onChange={changePermissions}
                >
                  {components.map((component) => (
                    <option
                      value={
                        JSON.stringify(component)
                      }
                      key={component._id}
                    >
                      {component.name}

                    </option>
                  ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  Por favor, entre com a instituição.
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} md="6" controlId="validationSelectt">
                <Form.Label>Permissões do usuário</Form.Label>
                <Form.Control
                  as="select"
                  name="college"
                  custom
                  multiple
                  onChange={changeComponents}

                >
                  {permissions.map((permission) => (
                    <option
                      value={
                        JSON.stringify(permission)
                      }
                      key={permission._id}
                    >
                      {permission.name}

                    </option>
                  ))}
                </Form.Control>
                <Form.Control.Feedback type="invalid">
                  Por favor, entre com a instituição.
                </Form.Control.Feedback>
              </Form.Group>
            </Form.Row>

          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Fechar
          </Button>
          <Button variant="primary" onClick={handleSubmitUpdateUser}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
